<template>
  <b-modal
    :ref="modalRef"
    :id="`editCampaignGroupModal`"
    :title="`Edit Campaign group`"
    data-test="edit-campaign-group-modal"
    hide-backdrop
    @shown="onShown"
  >
    <div class="d-block">
      <b-form-group
        id="fieldset-campaign-group"
        label="Campaign Group Name"
        label-for="campaign-group-input"
        :state="isDisabled"
      >
        <b-input
          id="campaign-group-input"
          placeholder="Enter a campaign group"
          v-model="campaignGroupName"
        />
      </b-form-group>
    </div>
    <template #modal-footer>
      <b-btn
        class="border-0"
        @click="onCancel"
      >
        Cancel
      </b-btn>
      <b-btn
        variant="primary"
        @click="onSave"
        :disabled="isDisabled"
      >
        Save
      </b-btn>
    </template>
  </b-modal>
</template>

<script>

import { mapActions } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'EditCampaignToGroupModal',
  props: {
    advertiserId: {
      type: Number,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      existingCampaignGroupName: '',
      campaignGroupName: '',
    };
  },
  computed: {
    modalRef() {
      return `editCampaignGroupModal-${this.id}`;
    },
    isDisabled() {
      return !this.campaignGroupName || (this.campaignGroupName === this.existingCampaignGroupName);
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.UPDATE_CAMPAIGN_GROUP,
    ]),
    showModal() {
      this.$refs[this.modalRef].show();
    },
    hideModal() {
      this.$refs[this.modalRef].hide();
    },
    onShown() {
      this.existingCampaignGroupName = this.group;
      this.campaignGroupName = this.group;
    },
    onCancel() {
      this.hideModal();
    },
    async onSave() {
      const payload = {
        advertiserId: this.advertiserId,
        group: this.existingCampaignGroupName,
        data: {
          group: this.campaignGroupName,
        },
      };

      await this.UPDATE_CAMPAIGN_GROUP(payload);
      this.refreshTable();
    },
    refreshTable() {
      this.$emit('refreshTable');
    },
  },
};
</script>
